import { SuppliesActionTypes } from './supplies.types'

//Add Supplies Category
export const addSuppliesCategoryRequest = data => ({
    type: SuppliesActionTypes.ADD_SUPPLIES_CATEGORY_REQUEST,
    payload: data
})

export const addSuppliesCategoryRequestSuccess = data => ({
    type: SuppliesActionTypes.ADD_SUPPLIES_CATEGORY_REQUEST_SUCCESS,
    payload: data
})

export const addSuppliesCategoryRequestError = data => ({
    type: SuppliesActionTypes.ADD_SUPPLIES_CATEGORY_REQUEST_ERROR,
    payload: data
})

export const addSuppliesCategoryRequestStatus = data => ({
    type: SuppliesActionTypes.ADD_SUPPLIES_CATEGORY_REQUEST_STATUS,
    payload: data
})

//Supplies Category List
export const suppliesCategoryListRequest = data => ({
    type: SuppliesActionTypes.SUPPLIES_CATEGORY_LIST_REQUEST,
    payload: data
})

export const suppliesCategoryListRequestSuccess = data => ({
    type: SuppliesActionTypes.SUPPLIES_CATEGORY_LIST_REQUEST_SUCCESS,
    payload: data
})

export const suppliesCategoryListRequestError = data => ({
    type: SuppliesActionTypes.SUPPLIES_CATEGORY_LIST_REQUEST_ERROR,
    payload: data
})

//Update Supplies Category
export const updateSuppliesCategoryDetailRequest = data => ({
    type: SuppliesActionTypes.UPDATE_SUPPLIES_CATEGORY_DETAIL_REQUEST,
    payload: data
})

export const updateSuppliesCategoryDetailRequestSuccess = data => ({
    type: SuppliesActionTypes.UPDATE_SUPPLIES_CATEGORY_DETAIL_REQUEST_SUCCESS,
    payload: data
})

export const updateSuppliesCategoryDetailRequestError = data => ({
    type: SuppliesActionTypes.UPDATE_SUPPLIES_CATEGORY_DETAIL_REQUEST_ERROR,
    payload: data
})

export const updateSuppliesCategoryDetailRequestStatus = data => ({
    type: SuppliesActionTypes.UPDATE_SUPPLIES_CATEGORY_DETAIL_REQUEST_STATUS,
    payload: data
})

//Add Supplies Item
export const addSuppliesItemRequest = data => ({
    type: SuppliesActionTypes.ADD_SUPPLIES_ITEM_REQUEST,
    payload: data
})

export const addSuppliesItemRequestSuccess = data => ({
    type: SuppliesActionTypes.ADD_SUPPLIES_ITEM_REQUEST_SUCCESS,
    payload: data
})

export const addSuppliesItemRequestError = data => ({
    type: SuppliesActionTypes.ADD_SUPPLIES_ITEM_REQUEST_ERROR,
    payload: data
})

export const addSuppliesItemRequestStatus = data => ({
    type: SuppliesActionTypes.ADD_SUPPLIES_ITEM_REQUEST_STATUS,
    payload: data
})

//Supplies Item List
export const suppliesItemListRequest = data => ({
    type: SuppliesActionTypes.SUPPLIES_ITEM_LIST_REQUEST,
    payload: data
})

export const suppliesItemListRequestSuccess = data => ({
    type: SuppliesActionTypes.SUPPLIES_ITEM_LIST_REQUEST_SUCCESS,
    payload: data
})

export const suppliesItemListRequestError = data => ({
    type: SuppliesActionTypes.SUPPLIES_ITEM_LIST_REQUEST_ERROR,
    payload: data
})

//Supplies Item Detail
export const suppliesItemDetailRequest = data => ({
    type: SuppliesActionTypes.SUPPLIES_ITEM_DETAIL_REQUEST,
    payload: data
})

export const suppliesItemDetailRequestSuccess = data => ({
    type: SuppliesActionTypes.SUPPLIES_ITEM_DETAIL_REQUEST_SUCCESS,
    payload: data
})

export const suppliesItemDetailRequestError = data => ({
    type: SuppliesActionTypes.SUPPLIES_ITEM_DETAIL_REQUEST_ERROR,
    payload: data
})

//Consume Supplies Item
export const consumeSuppliesItemRequest = data => ({
    type: SuppliesActionTypes.CONSUME_SUPPLIES_ITEM_REQUEST,
    payload: data
})

export const consumeSuppliesItemRequestSuccess = data => ({
    type: SuppliesActionTypes.CONSUME_SUPPLIES_ITEM_REQUEST_SUCCESS,
    payload: data
})

export const consumeSuppliesItemRequestError = data => ({
    type: SuppliesActionTypes.CONSUME_SUPPLIES_ITEM_REQUEST_ERROR,
    payload: data
})

export const consumeSuppliesItemRequestStatus = data => ({
    type: SuppliesActionTypes.CONSUME_SUPPLIES_ITEM_REQUEST_STATUS,
    payload: data
})

//Update Supplies Item Stock
export const updateSuppliesItemStockRequest = data => ({
    type: SuppliesActionTypes.UPDATE_SUPPLIES_ITEM_STOCK_REQUEST,
    payload: data
})

export const updateSuppliesItemStockRequestSuccess = data => ({
    type: SuppliesActionTypes.UPDATE_SUPPLIES_ITEM_STOCK_REQUEST_SUCCESS,
    payload: data
})

export const updateSuppliesItemStockRequestError = data => ({
    type: SuppliesActionTypes.UPDATE_SUPPLIES_ITEM_STOCK_REQUEST_ERROR,
    payload: data
})

export const updateSuppliesItemStockRequestStatus = data => ({
    type: SuppliesActionTypes.UPDATE_SUPPLIES_ITEM_STOCK_REQUEST_STATUS,
    payload: data
})